// web/src/services/schedulesService.js
import apiClient from './apiClient';
import toast from 'react-hot-toast';

/**
 * Get schedules for a physician
 */
export const getPhysicianSchedules = async (physicianId) => {
  try {
    const data = await apiClient.get(`/schedules/physician/${physicianId}`);
    return { data, error: null };
  } catch (error) {
    console.error('Error fetching physician schedules:', error);
    return { data: null, error };
  }
};

/**
 * Get available time slots for a physician
 */
export const getAvailableTimeSlots = async (physicianId, startDate, endDate, slotDurationMinutes = 30) => {
  try {
    const params = new URLSearchParams({
      startDate,
      endDate,
      slotDurationMinutes: slotDurationMinutes.toString(),
    });
    const data = await apiClient.get(`/schedules/physician/${physicianId}/available-slots?${params.toString()}`);
    return { data: data?.data || data || [], error: null };
  } catch (error) {
    console.error('Error fetching available time slots:', error);
    return { data: [], error };
  }
};

/**
 * Create or update physician schedule
 */
export const upsertSchedule = async (scheduleData) => {
  try {
    const data = await apiClient.post('/schedules', scheduleData);
    toast.success('Schedule saved successfully');
    return { data, error: null };
  } catch (error) {
    console.error('Error saving schedule:', error);
    toast.error(error.message || 'Failed to save schedule');
    return { data: null, error };
  }
};

/**
 * Delete physician schedule
 */
export const deleteSchedule = async (scheduleId) => {
  try {
    await apiClient.delete(`/schedules/${scheduleId}`);
    toast.success('Schedule deleted successfully');
    return { data: true, error: null };
  } catch (error) {
    console.error('Error deleting schedule:', error);
    toast.error(error.message || 'Failed to delete schedule');
    return { data: null, error };
  }
};

/**
 * Get availability overrides for a physician
 */
export const getAvailabilityOverrides = async (physicianId, startDate, endDate) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    
    const queryString = params.toString();
    const url = `/schedules/physician/${physicianId}/overrides${queryString ? `?${queryString}` : ''}`;
    const data = await apiClient.get(url);
    return { data: data?.data || data || [], error: null };
  } catch (error) {
    console.error('Error fetching availability overrides:', error);
    return { data: [], error };
  }
};

/**
 * Create or update availability override
 */
export const upsertAvailabilityOverride = async (overrideData) => {
  try {
    const data = await apiClient.post('/schedules/overrides', overrideData);
    toast.success('Availability override saved successfully');
    return { data, error: null };
  } catch (error) {
    console.error('Error saving availability override:', error);
    toast.error(error.message || 'Failed to save availability override');
    return { data: null, error };
  }
};

export default {
  getPhysicianSchedules,
  getAvailableTimeSlots,
  upsertSchedule,
  deleteSchedule,
  getAvailabilityOverrides,
  upsertAvailabilityOverride,
};

